import Constructions from "../../Portal/Accessor/Construction/Constructions";
import InternalExternalConstructionDetailV001 from "../../Portal/Accessor/Construction/V001/InternalExternalConstructionDetail";
import WindowConstructionDetailV001 from "../../Portal/Accessor/Construction/V001/WindowConstructionDetail";
import SkylightRoofWindowConstructionDetailV001 from "../../Portal/Accessor/Construction/V001/SkylightRoofWindowConstructionDetail";
const AccessorConstructionRouters = [
    {
      path: "ConstructionAssessor/Constructions/:designVariationVersionName/:developmentId/:projectId/:designVariationId",
      exact: true,
      requireAuth: true,
      element: <Constructions/>,
      title: "Constructions | AccuRate Enterprise",
    },
    {
      path: "ConstructionAssessor/Detail/Skylight/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:constructionId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <SkylightRoofWindowConstructionDetailV001 typeName="Skylight"/>,
      title: "Construction | AccuRate Enterprise",
    },
    {
      path: "ConstructionAssessor/Detail/RoofWindow/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:constructionId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <SkylightRoofWindowConstructionDetailV001 typeName="RoofWindow"/>,
      title: "Construction | AccuRate Enterprise",
    },
    {
      path: "ConstructionAssessor/Detail/Window/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:constructionId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <WindowConstructionDetailV001 typeName="Window"/>,
      title: "Construction | AccuRate Enterprise",
    },
    {
      path: "ConstructionAssessor/LibraryDetail/Skylight/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:constructionId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <SkylightRoofWindowConstructionDetailV001 typeName="Skylight" isLibrary={true}/>,
      title: "Construction | AccuRate Enterprise",
    },
    {
      path: "ConstructionAssessor/LibraryDetail/RoofWindow/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:constructionId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <SkylightRoofWindowConstructionDetailV001 typeName="RoofWindow" isLibrary={true}/>,
      title: "Construction | AccuRate Enterprise",
    },
    {
      path: "ConstructionAssessor/LibraryDetail/Window/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:constructionId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <WindowConstructionDetailV001 typeName="Window" isLibrary={true}/>,
      title: "Construction | AccuRate Enterprise",
    },
    {
        path: "ConstructionAssessor/Detail/:typeName/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:constructionId/:redirectUrlHex",
        exact: true,
        requireAuth: true,
        element: <InternalExternalConstructionDetailV001/>,
      title: "Construction | AccuRate Enterprise",
    },
    {
      path: "ConstructionAssessor/LibraryDetail/:typeName/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:constructionId/:redirectUrlHex",
      exact: true,
      requireAuth: true,
      element: <InternalExternalConstructionDetailV001 isLibrary={true}/>,
      title: "Construction | AccuRate Enterprise",
    },
  ];
export default AccessorConstructionRouters;